import { flashSuccess } from '/app/app/assets/js/utils/flash.js'

export default (message) => ({
  copy() {
    navigator.clipboard.writeText(this.$refs.code.textContent)
    flashSuccess(message)
  },
})
